import { render, staticRenderFns } from "./approvalImage.vue?vue&type=template&id=6e1e3d5c&scoped=true&"
import script from "./approvalImage.vue?vue&type=script&lang=js&"
export * from "./approvalImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1e3d5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e1e3d5c')) {
      api.createRecord('6e1e3d5c', component.options)
    } else {
      api.reload('6e1e3d5c', component.options)
    }
    module.hot.accept("./approvalImage.vue?vue&type=template&id=6e1e3d5c&scoped=true&", function () {
      api.rerender('6e1e3d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ActivityData/approvalImage.vue"
export default component.exports